import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SwatchImage = {
  url: string;
  name: string;
  value: string;
};
type DAMType = {
  isDAM: boolean;
  error: any;
  retriveFullPath: (_: string) => string;
  imagePaths: any;
};
export type StateColor = {
  colorSelected: string;
  colorAndTechnology: {};
  colorCategory?: string;
  colorDesc?: string;
  stepColor?: string;
  transitionSelected: string;
  isError: boolean;
  showFallbackImageMessage: boolean;
  showNotFoundImageMessage: boolean;
  recommendedUseSelected: string;
  lensBrand?: string;
  swatchImage?: SwatchImage;
  DAM?: DAMType;
  suitableForDriving: boolean;
  frameImgUrl?: string;
  isLoading: boolean;
  urlImage: string;
  clearClen?: string;
  cardTransitionImage: {
    id: string | null;
    imageFileName1: string | null;
    imageFileName2: string | null;
  };
  isNestedTransitionSwatchEnabled: boolean;
  frameColorSelected?: any;
};

const initialState: StateColor = {
  colorSelected: null,
  colorAndTechnology: null,
  colorDesc: null,
  colorCategory: null,
  stepColor: null,
  transitionSelected: null,
  isError: false,
  showFallbackImageMessage: false,
  showNotFoundImageMessage: false,
  recommendedUseSelected: null,
  lensBrand: null,
  swatchImage: null,
  DAM: undefined,
  suitableForDriving: true,
  isLoading: false,
  urlImage: '',
  frameImgUrl: '',
  clearClen: '',
  cardTransitionImage: {
    id: null,
    imageFileName1: null,
    imageFileName2: null,
  },
  isNestedTransitionSwatchEnabled: false,
  frameColorSelected: null,
};

const colorSlice = createSlice({
  name: 'colorSelected',
  initialState: initialState,
  reducers: {
    setFrameColorSelected: (state, { payload }) => {
      state.frameColorSelected = { ...payload };
    },
    setUrlImageGlobal: (state, { payload }) => {
      state.urlImage = payload;
    },
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setSuitableForDriving: (state, { payload }) => {
      state.suitableForDriving = payload;
    },
    selectColor: (state, { payload }: PayloadAction<string>) => {
      state.colorSelected = payload;
    },
    selectColorAndTechnology: (state, payload) => {
      state.colorAndTechnology = payload;
    },
    selectColorCategory: (state, { payload }: PayloadAction<string>) => {
      state.colorCategory = payload;
    },
    selectColorDesc: (state, { payload }: PayloadAction<string>) => {
      state.colorDesc = payload;
    },
    selectRecommendedUse: (state, { payload }: PayloadAction<string>) => {
      state.recommendedUseSelected = payload;
    },
    selectTransition: (state, { payload }: PayloadAction<string>) => {
      state.transitionSelected = payload;
    },
    // step dove viene selezionato il colore della lente
    setStepColor: (state, { payload }: PayloadAction<string>) => {
      state.stepColor = payload;
    },
    setError: (state, { payload }: PayloadAction<boolean>) => {
      state.isError = payload;
    },
    setShowFallbackImageMessage: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showFallbackImageMessage = payload;
    },
    setShowNotFoundImageMessage: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showNotFoundImageMessage = payload;
    },
    setLensBrand: (state, action: PayloadAction<string>) => {
      state.lensBrand = action.payload;
    },
    setSwatchUrl: (state, { payload }: PayloadAction<SwatchImage>) => {
      state.swatchImage = payload;
    },
    setDAMObj: (state, { payload }: PayloadAction<DAMType>) => {
      state.DAM = payload;
    },
    setFrameImgUrl: (state, action: PayloadAction<string>) => {
      state.frameImgUrl = action.payload;
    },
    setClearClen: (state, action: PayloadAction<string>) => {
      state.clearClen = action.payload;
    },
    setCardTransitionImage(state, action: PayloadAction<any>) {
      state.cardTransitionImage = action.payload;
    },
    setIsNestedTransitionSwatchEnabled(state, action: PayloadAction<any>) {
      state.isNestedTransitionSwatchEnabled = action.payload;
    },
    reset: (state, { payload }: PayloadAction<string>) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
      });
    },
  },
});

export const colorReducer = colorSlice.reducer;
export const colorActions = colorSlice.actions;
